import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import { IDRCXTimeAndDuration } from "../../../common/models/drcx/DRCXTimeAndDuration";
import { IeLynxObject } from "../../../common/models/eLynxObject";
import { IDateRange } from "../../../common/models/IDateRange";
import i18n from "../../../services/localization-service/i18n";
import { ITrendingDisplayOptions } from "../../../services/trending-data-service/Models";
import { CustomDurationDialogValues } from "../../custom-duration-dialog/CustomDurationDialog";
import { DurationOptionEnum } from "../../custom-duration-dialog/CustomDurationUtils";


export const dateRangeOptions = [
    { id: 2, name: i18n.t("enums.dateRangeType.hour") },
    { id: 3, name: i18n.t("enums.dateRangeType.day") },
    { id: 5, name: i18n.t("enums.dateRangeType.month") },
    { id: 6, name: i18n.t("enums.dateRangeType.year") },
];

export type ObjectGraphOptionsDialogValues = {

    groupID?: number;
    contextObject: IeLynxObject;

    contextObjectType: eLynxObjectTypeEnum;


    displayOptions: ITrendingDisplayOptions | undefined;
    sectionCount?: number;
    hideShowStacked?: boolean;
    hideShowAdditional?: boolean;

    durationOptions?: CustomDurationDialogValues;

    showReset?: boolean;


    showConfigurationSelector?: boolean;
    showGroupSelector?: boolean;
    showDeviceSelector?: boolean;

    configurationID?: number;
    configurationName?: string;
}


export type ObjectGraphOptionsDialogFormValuesType = {


    objectID: number | null;
    objectType: eLynxObjectTypeEnum;
    objectName: string | null;


    deviceID: number | null;



    configurationID: number | null;


    comparisonTimeAndDuration: IDRCXTimeAndDuration | null;
    displayAlarms: boolean;
    displayDataQualityEvents: boolean;
    displayDiagnosticEvents: boolean;
    displayManualEvents: boolean;
    displayLegend: boolean;
    displayMemos: boolean;
    displaySectionsStacked: boolean;
    displayTabularData: boolean;
    displaySettingsChanges: boolean;
    displaySimulationDataQualityEvents: boolean;
    displaySimulationDiagnosticEvents: boolean;
    hasComparisonTimeframe: boolean;

    option: DurationOptionEnum;    
    duration: IDateRange | null;
};

const ObjectGraphOptionsUtils = {


    mapToForm: (model: ObjectGraphOptionsDialogValues, 
    ): ObjectGraphOptionsDialogFormValuesType  => {

        const formValues: ObjectGraphOptionsDialogFormValuesType = {
            objectID: model.contextObject.objectType === eLynxObjectTypeEnum.Device ? 
                                    model.groupID ?? null : 
                                    model.contextObject.id === -1 ? 
                                        null : 
                                    model.contextObject.id,
            objectType: model.contextObject.objectType,
            objectName: model.contextObject.displayText ?? null,

            deviceID: model.contextObject.objectType === eLynxObjectTypeEnum.Device ? model.contextObject.id === -1 ? 
                            null : 
                        model.contextObject.id : null,

            //comparisonTimeAndDuration: model.displayOptions!.comparisonTimeAndDuration ? {...model.displayOptions!.comparisonTimeAndDuration} : null,
            configurationID: null,
            comparisonTimeAndDuration: null,
            displayAlarms: model.displayOptions!.displayAlarms ?? false,
            displayDataQualityEvents: model.displayOptions!.displayDataQualityEvents ?? false,
            displayDiagnosticEvents: model.displayOptions!.displayDiagnosticEvents ?? false,
            displayManualEvents: model.displayOptions!.displayManualEvents ?? false,
            displayLegend: model.displayOptions!.displayLegend ?? false,
            displayMemos: model.displayOptions!.displayMemos ?? false,
            displaySectionsStacked: model.displayOptions!.displaySectionsStacked ?? false,
            displayTabularData: model.displayOptions!.displayTabularData ?? false,
            displaySettingsChanges: model.displayOptions!.displaySettingsChanges ?? false,
            displaySimulationDataQualityEvents: model.displayOptions!.displaySimulationDataQualityEvents ?? false,
            displaySimulationDiagnosticEvents:  model.displayOptions!.displaySimulationDiagnosticEvents ?? false,
            hasComparisonTimeframe:  model.displayOptions!.hasComparisonTimeframe ?? false,
            option: model.durationOptions?.option ?? DurationOptionEnum.Default,
            duration: model.durationOptions?.duration ?? null,
        };

        return formValues;
    },
    mapToModel: (form: ObjectGraphOptionsDialogFormValuesType, 
        ): ObjectGraphOptionsDialogValues  => {
    
            const model: ObjectGraphOptionsDialogValues = {

                groupID: form.objectID ?? undefined, 
                contextObjectType: form.objectType,
                contextObject: {
                    id: form.objectType === eLynxObjectTypeEnum.Group ? (form.objectID ?? undefined) : (form.deviceID ?? undefined),
                    objectType: form.objectType,
                    displayText: form.objectName

                } as IeLynxObject,
                
                configurationID: form.configurationID ?? undefined,
                displayOptions: {
                    
    
                    comparisonTimeAndDuration: form.comparisonTimeAndDuration ?? undefined,
                    displayAlarms: form.displayAlarms,
                    displayDataQualityEvents: form.displayDataQualityEvents,
                    displayDiagnosticEvents: form.displayDiagnosticEvents,
                    displayManualEvents: form.displayManualEvents,
                    displayLegend: form.displayLegend,
                    displayMemos: form.displayMemos,
                    displaySectionsStacked: form.displaySectionsStacked,
                    displayTabularData: form.displayTabularData,
                    displaySettingsChanges: form.displaySettingsChanges,
                    displaySimulationDataQualityEvents: form.displaySimulationDataQualityEvents,
                    displaySimulationDiagnosticEvents:  form.displaySimulationDiagnosticEvents,
                    hasComparisonTimeframe:  form.hasComparisonTimeframe,
                },
                durationOptions: form.option !== null && form.duration !== null ? {
                    option: form.option,
                    duration: form.duration
                } : undefined,

            };
    
            return model;
        },
    


    
};

export default ObjectGraphOptionsUtils;
